// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2L2I-","itemTitle":"ClientEmergencyInfo_itemTitle__1MkLN","itemText":"ClientEmergencyInfo_itemText__19o0W"};